import Vue from 'vue';
import Router from 'vue-router';
import i18n from '@/i18n';
import bonesconfig from '@/sav/config';

import Index from '@/views/Index';
import Inquiries from '@/views/Inquiries';
import Users from '@/views/Users';
import Branches from '@/views/Branches';
import Statistics from '@/views/Statistics';
import Inquiry from '@/views/Inquiry';
import Review from '@/views/Review';
import User from '@/views/User';
import Support from '@/views/Support';
import Resources from '@/views/Resources';

const { APP_BASE_URL, LANGUAGES } = bonesconfig;

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: APP_BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {},
    },
    {
      path: '/changelog/:version?',
      name: 'changelog',
      component: () => import(/* webpackChunkName: "changelog" */ './views/DetailedChangelog'),
      props: route => ({ version: route.params.version }),
      meta: { public: true },
    },
    {
      path: '/reset',
      name: 'index-reset',
      component: Index,
      meta: {},
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {},
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      meta: {},
    },
    {
      path: '/branches',
      name: 'branches',
      component: Branches,
      meta: {},
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: Statistics,
      meta: {},
    },
    {
      path: '/inquiries',
      name: 'inquiries',
      component: Inquiries,
      meta: {},
    },
    {
      path: '/inquiry',
      name: 'inquiry-create',
      component: Inquiry,
      meta: {},
    },
    {
      path: '/inquiry/:id',
      name: 'inquiry-edit',
      component: Inquiry,
      props: route => ({ uuid: route.params.id }),
      meta: {},
    },
    {
      path: '/review/:id',
      name: 'review',
      component: Review,
      props: route => ({ uuid: route.params.id }),
      meta: {},
    },
    /*
    {
      path: '/anonymize/:id',
      name: 'anonymize',
      component: Anonymize,
      props: route => ({ uuid: route.params.id }),
      meta: {},
    },
    */
    {
      path: '/resources',
      name: 'resources',
      component: Resources,
      meta: {},
    },
    {
      path: '/support',
      name: 'support',
      component: Support,
      meta: {},
    },
    {
      path: '/debug',
      name: 'debug',
      component: () => import(/* webpackChunkName: "debug" */ './views/Debug'),
      meta: {},
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeResolve(async (to, from, next) => {
  const language = (to.params.lang) ? to.params.lang : to.query.lang || 'de';
  if (i18n.locale !== language) {
    const requestedLanguage = LANGUAGES.includes(language) ? language : LANGUAGES[0];
    // eslint-disable-next-line
    const messages = await import(/* webpackChunkName: "i18n-[request]" */ '@/locales/' + requestedLanguage);
    i18n.setLocaleMessage(requestedLanguage, messages.default);
    document.documentElement.lang = requestedLanguage;
    i18n.locale = requestedLanguage;
    Vue.nextTick(() => {
      i18n.silentTranslationWarn = false;
    });
  }
  next();
  return null;
});

export default router;
